/* template */
<template minapp="mpx" xlang="wxml"><div class="content-table"><div class="title" v-if="(tableValue.title)">{{tableValue.title}}</div><table class="main-table"><tbody><tr><th width="100px">{{tableValue.tableth[0]}}</th><th>{{tableValue.tableth[1]}}</th></tr><tr v-for="(item, index) in (tableValue.tablelist)" :key="item.index" class="table-content"><td>{{item.title}}</td><td><div v-for="(item, index) in (item.content)" class="label"><div class="label-text" v-if="(item.submit_title)">{{item.submit_title}}</div><mpx-rich-text :nodes="(item.text)"></mpx-rich-text></div></td></tr></tbody></table></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m23c58dd2"}'>
  .content-table
    position static
    left 0px
    top 0px
    border-radius 8px
    opacity 1
    /* 自动布局 */
    display flex
    flex-direction column
    padding 0px
    box-sizing border-box
    /* 纯白 */
    background #FFFFFF
    z-index 0
    .title
      display flex
      height 46px
      align-items center
      margin 0 12px
      border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      line-height 19px
      letter-spacing 0px
      color #1473FF

    .main-table
      // width: 100%;
      margin 12px 12px 0
      border-radius: 4px;
      border-collapse: collapse;
      margin-bottom: 12px;
      border-radius: 4px;
      overflow: hidden;
      th, td
        border: 1px solid #e5e5e5;
        padding: 8px 12px;
        box-sizing: border-box;
        color: #666;
        font-size: 14px;
      th
        text-align: left;
        padding: 8px 12px;
        background: rgba(231, 241, 255, 0.3);
        box-sizing: border-box;
        border-color: rgba(0, 0, 0, 0.08);
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        letter-spacing: 0px;
        color: #666666;
      td
        box-sizing border-box
        padding 12px
        background: #fff;
        vertical-align middle
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        line-height: 16px;
        letter-spacing: 0px;
        color: #666666;
        z-index: 1;
        .label 
          display flex
          margin-bottom 8px
          &:last-child
            margin 0
        .label-text
          width: 70px;
          float: left;
          flex-shrink 0
          white-space: nowrap;

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m23c58dd2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ticket-table.mpx.js?isComponent&outputPath=components%2Fticket-table23c58dd2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ticket-table.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fticket-table23c58dd2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m23c58dd2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ticket-table23c58dd2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-rich-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
